var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('Logo'),_c('div',[_c('button',{staticClass:"block lg:hidden",on:{"click":_vm.navOpen}},[_c('img',{attrs:{"src":require("@/assets/images/icons/menu.svg"),"alt":"icons"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }